package diana.soleil.design.iraniancanadienbazzar.feature.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.runtime.collectAsState
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.data.FeatureFlags
import diana.soleil.design.iraniancanadienbazzar.core.data.LocationController
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/**
 * Stateful entry for Home: resolves [HomeViewModel] from Koin, exposes the active metro for the city
 * selector, and forwards navigation callbacks. Changing the metro re-queries the lists live.
 */
@Composable
fun HomeRoute(
    modifier: Modifier = Modifier,
    onSearch: () -> Unit = {},
    onOpenMap: () -> Unit = {},
    onNotifications: () -> Unit = {},
    currentLanguage: diana.soleil.design.iraniancanadienbazzar.core.model.Language = diana.soleil.design.iraniancanadienbazzar.core.model.Language.Default,
    onSelectLanguage: (diana.soleil.design.iraniancanadienbazzar.core.model.Language) -> Unit = {},
    onOpenMessages: (() -> Unit)? = null,
    onOpenPeople: () -> Unit = {},
    onOpenPeopleMap: () -> Unit = {},
    onOpenPerson: (uid: String) -> Unit = {},
    onSeeAllCategories: () -> Unit = {},
    onCategoryClick: (categoryId: String) -> Unit = {},
    onBusinessClick: (String) -> Unit = {},
    onNewsClick: (articleId: String) -> Unit = {},
    onSeeAllNews: () -> Unit = {},
    onOpenGems: () -> Unit = {},
    onOpenEvents: () -> Unit = {},
    onOpenEventDetail: (eventId: String) -> Unit = {},
    viewModel: HomeViewModel = koinViewModel(),
    locationController: LocationController = koinInject(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val activeMetroId by viewModel.activeMetroId.collectAsStateWithLifecycle()
    val unreadCount by viewModel.unreadCount.collectAsStateWithLifecycle()
    val favorites by viewModel.favorites.collectAsStateWithLifecycle()
    val userLocation by locationController.location.collectAsStateWithLifecycle()
    val features by koinInject<FeatureFlags>().available.collectAsState()
    // Home does NOT ask for location (2026-09-11): the OS prompt on the very first screen was one of
    // four interruptions before a new member saw a business. The map, list and search screens ask
    // when the member reaches them; until then the cards show the business's city instead of a
    // distance, and a fix obtained anywhere flows back here through [LocationController].
    HomeScreen(
        state = state,
        activeMetroId = activeMetroId,
        onSelectMetro = viewModel::selectMetro,
        onSelectCountry = viewModel::selectCountry,
        modifier = modifier,
        unreadCount = unreadCount,
        userLocation = userLocation,
        onSearch = onSearch,
        onOpenMap = onOpenMap,
        onNotifications = onNotifications,
        currentLanguage = currentLanguage,
        onSelectLanguage = onSelectLanguage,
        onOpenMessages = onOpenMessages,
        onOpenPeople = onOpenPeople,
        onOpenPeopleMap = onOpenPeopleMap,
        onOpenPerson = onOpenPerson,
        onSeeAllCategories = onSeeAllCategories,
        onCategoryClick = onCategoryClick,
        onBusinessClick = onBusinessClick,
        onNewsClick = onNewsClick,
        onSeeAllNews = onSeeAllNews,
        favorites = favorites,
        onToggleFavorite = viewModel::toggleFavorite,
        onRetry = viewModel::retry,
        gemsEnabled = features.hiddenGems,
        onOpenGems = onOpenGems,
        eventsEnabled = features.events,
        peopleEnabled = features.people,
        onOpenEvents = onOpenEvents,
        onOpenEventDetail = onOpenEventDetail,
        denseSections = features.homeDenseSections,
    )
}
